module.exports = __webpack_public_path__ + "img/s1_img@2x.3a8e1930.png";